// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3F2XI","title":"AfterBackImages_title__2VY8I","images":"AfterBackImages_images__3htyN"};